export const WRAP_AROUND_GROUP = {
  imageFrom: 'wrap_around',
  filter: '[shield,Shield,wrap_around]',
}

export const FULL_RIM_GROUP = {
  imageFrom: 'full_rim',
  filter: '[full_rim,FullRim]',
}

export const HALF_RIM_GROUP = {
  imageFrom: 'half_rim',
  filter: '[half_rim,HalfRim]',
}

export const CAT_EYE_GROUP = {
  imageFrom: 'cat_eye',
  filter: '[cat_eye,Cat__Eye]',
}

export const MED_SIZE_GROUP = {
  labelToInsert: 'M',
  filter: '[Med,medium]',
}

export const XS_SIZE_GROUP = {
  labelToInsert: 'XS',
  filter: '[extrasmall,Extra_Small]',
}

export const XL_SIZE_GROUP = {
  labelToInsert: 'XL',
  filter: '[extralarge,Extra_Large]',
}
